module.exports = __webpack_public_path__ + "img/media-22.72e3480e.png";